<template>
  <div>
    <div class="p-24" v-if="task && task.type == 'client'">
      <div class="heading-small mb-16">Project details</div>
      <div>
        <span>Project:</span> <span class="heading-small">
        <skeleton-text :until="task">
          <div v-if="task" style="max-width: 20rem;">
            {{ _task_project_name }}
          </div>
        </skeleton-text>
      </span>
      </div>
      <div class="mt-8">
        <span>Client:</span> <span class="heading-small">
        <skeleton-text :until="task">
          <div v-if="task">
            {{ _task_client_name }}
          </div>
        </skeleton-text>
      </span>
      </div>
      <div class="mt-8">
        <span>Manager:</span> <span class="heading-small">
        <skeleton-text :until="task">
          <div v-if="task">
            {{ _task_client_manager_name }}
          </div>
        </skeleton-text>
      </span>
      </div>
      <div class="mt-24 progress-bar-holder">
        <div class="mr-2">Project progress</div>
        <progress-bar :fill="_project_completion"></progress-bar>
      </div>
      <div class="deadline mt-8" v-if="task && _project_deadline">
        <div>Project deadline</div>
        <div class="heading-small">{{ _project_deadline }}</div>
      </div>
    </div>
    <div class="divider mt-24 mb-24" v-if="task && task.type == 'client'"></div>
    <div style="height: 50px;" v-if="task && task.type == 'internal'"></div>
    <div class="comments">
      <skeleton-text :until="task">
        <div v-if="task">
          <div class="comment" v-for="comment in task.comments">
            <div class="heading">
              <span class="font-weight-bold color-jet" style="font-size: 1rem;">{{ comment.user.name }}</span>
              ({{ comment.created_at_human }})
            </div>
            <div v-if="comment.agenda_date_human" style="font-style: italic; font-size: 1rem; margin-bottom: 5px;">In agenda {{ comment.agenda_date_human }}</div>
            <div class="text" v-html="comment.comment"></div>
          </div>
        </div>
      </skeleton-text>
    </div>
  </div>
</template>
<script>
import ProgressBar from '../../../components/progress-bar'

export default {
  components: {
    ProgressBar,
  },
  props: {
    task: {},
  },
  watch: {
    'task': function () {
      this.updateCommentsMaxHeight()
    }
  },
  computed: {
    _task_project_name() {
      return this.task && this.task.project ? this.task.project.name : null
    },
    _task_client_name() {
      return this.task && this.task.client ? this.task.client.name : null
    },
    _task_client_manager_name() {
      return this.task && this.task.client && this.task.client.manager ? this.task.client.manager.name : null
    },
    _project_completion() {
      return this.task && this.task.project ? this.task.project.completion_percentage : 0
    },
    _project_deadline() {
      return this.task && this.task.project && this.task.project.deadline ? moment(this.task.project.deadline).format('YYYY-MM-DD') : null
    }
  },
  methods: {
    updateCommentsMaxHeight() {
      let dmBody = document.querySelector('.show-task-modal .dm-body')
      let dmSidebar = document.querySelector('.show-task-modal .dm-sidebar')
      let bodyChildren = dmBody.querySelectorAll('.dm-body > div')
      let sidebarChildren = dmSidebar.querySelectorAll('.dm-sidebar > div > div:not(.comments)')
      let height = 0

      _.each(bodyChildren, child => {
        height += child.offsetHeight
      })
      _.each(sidebarChildren, child => {
        height -= child.offsetHeight
      })

      document.querySelector('.show-task-modal .comments').style['max-height'] = height + "px"
    }
  }
}
</script>
<style lang="scss">
.comments {
  overflow-y: scroll;
  //max-height: 50vh;

  &::-webkit-scrollbar {
    display: none;
  }
}

.progress-bar-holder {
  display: flex;
  width: 100%;
  align-items: center;
}
</style>



// WEBPACK FOOTER //
// src/views/agenda-v2/task-modal/task-sidebar.vue